import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { createAgent } from './services';
import { normalizeEmail, parseServerErrors } from './utils';

export const CreateAgentSlice = createSlice({
  name: 'CreateAgent',
  initialState,
  reducers: {
    setCreateAgentField: (state, action) => {
      const { field, value } = action.payload;
      state.fields[field] = value;
      delete state.serverErrors[field];

      if (field === 'canViewOtherBranches' && !value) {
        state.fields.inquiryBranchIds = [];
      }
      if (field === 'branchId') {
        state.fields.inquiryBranchIds = state.fields.inquiryBranchIds.filter(
          (id) => id !== value
        );
      }
    },
    // Rejected emails outlive a reset: retrying one still fails.
    resetCreateAgent: (state) => ({
      ...initialState,
      rejectedEmails: state.rejectedEmails,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAgent.pending, (state) => {
        state.submitStatus = 'loading';
        state.serverErrors = {};
      })
      .addCase(createAgent.fulfilled, (state) => {
        state.submitStatus = 'succeeded';
      })
      .addCase(createAgent.rejected, (state, action) => {
        state.submitStatus = 'failed';
        const { email, ...serverErrors } = parseServerErrors(
          action.payload?.errors
        );
        state.serverErrors = serverErrors;
        // Any email error repeats for the same address, so it's kept per email.
        if (email) {
          state.rejectedEmails[normalizeEmail(action.meta.arg.email)] = email;
        }
      });
  },
});

export const { setCreateAgentField, resetCreateAgent } =
  CreateAgentSlice.actions;

export default CreateAgentSlice.reducer;
